import { useEffect, useState } from "react";
import { GOOGLE_REVIEW_STORES, formatGoogleReviewMessage } from "./reviewMessage";

const STORES = [1, 2, 3, 4];
const buttonStyle = { border:"1px solid #CBD5E1", background:"#fff", borderRadius:8,
  padding:"8px 12px", cursor:"pointer", color:"#183049", fontWeight:700 };
const inputStyle = { width:"100%", boxSizing:"border-box", padding:"9px 10px",
  border:"1px solid #CBD5E1", borderRadius:8, marginTop:6 };

async function jsonRequest(url, options) {
  const response = await fetch(url, { credentials:"same-origin", cache:"no-store", ...options });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(body.error || `HTTP ${response.status}`);
  return body;
}

function formatDay(day) {
  return /^\d{4}-\d{2}-\d{2}$/.test(day || '')
    ? `${day.slice(8, 10)}/${day.slice(5, 7)}/${day.slice(0, 4)}` : "—";
}

function whatsappNumber(raw) {
  let digits = String(raw || "").replace(/\D/g, "");
  if (digits.startsWith("55") && [12, 13].includes(digits.length)) digits = digits.slice(2);
  if (digits.length === 10) digits = digits.slice(0, 2) + "9" + digits.slice(2);
  return digits.length === 11 ? `55${digits}` : null;
}

function ReviewLinksSettings({ onUpdated }) {
  const [links, setLinks] = useState({});
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    let cancelled = false;
    jsonRequest("/api/lift/review-links")
      .then(body => { if (!cancelled) setLinks(body.links || {}); })
      .catch(err => { if (!cancelled) setError(err.message); });
    return () => { cancelled = true; };
  }, []);
  const save = async storeId => {
    setBusy(true); setError(""); setMessage("");
    try {
      await jsonRequest(`/api/lift/review-links/${storeId}`, {
        method:"PUT", headers:{ "Content-Type":"application/json" },
        body:JSON.stringify({ url:links[storeId] || "" }),
      });
      setMessage(`Link da loja ${storeId} salvo.`);
      onUpdated();
    } catch (err) { setError(err.message); }
    finally { setBusy(false); }
  };
  return <details style={{ marginBottom:16, padding:14, background:"#F8FAFC", borderRadius:10 }}>
    <summary style={{ cursor:"pointer", fontWeight:700 }}>Configurar links de avaliação por loja (admin)</summary>
    <p style={{ fontSize:12 }}>Sem link salvo aqui, vale o link padrão da loja (já cadastrado no servidor). QR code para imprimir no balcão: {STORES.map(storeId => <a key={storeId} href={`/api/avaliacao/cartaz/${storeId}`} target="_blank" rel="noreferrer" style={{ marginRight:8, fontWeight:700 }}>loja {storeId}</a>)}</p>
    {STORES.map(storeId => <div key={storeId} style={{ display:"flex", gap:8, alignItems:"end", margin:"10px 0", flexWrap:"wrap" }}>
      <label style={{ flex:"1 1 210px" }}>Loja {storeId}
        <input type="url" aria-label={`Link de avaliação da loja ${storeId}`} style={inputStyle}
          value={links[storeId] || ""} placeholder="https://..."
          onChange={e => setLinks(previous => ({ ...previous, [storeId]:e.target.value }))} />
      </label>
      <button type="button" style={buttonStyle} disabled={busy} onClick={() => save(storeId)}>Salvar</button>
    </div>)}
    {error && <p role="alert" style={{ color:"#B91C1C" }}>{error}</p>}
    {message && <p role="status">{message}</p>}
  </details>;
}

function PostSaleCard({ sale, onSaved, manager, currentUser }) {
  const [problem, setProblem] = useState("");
  const [confirmed, setConfirmed] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const state = sale.postSaleState;
  const number = whatsappNumber(sale.cliente?.telefone);
  let reviewText = "";
  try {
    reviewText = formatGoogleReviewMessage({
      nome:sale.cliente?.nome, consultor:currentUser?.name,
      loja:GOOGLE_REVIEW_STORES[sale.storeId],
      produto:(sale.itens || []).find(item => item.produto || item.produtoLift)?.produto
        || (sale.itens || []).find(item => item.produtoLift)?.produtoLift || "",
      link:sale.reviewLink,
    });
  } catch { /* Falta dado obrigatório: não criar mensagem incompleta. */ }
  const submit = async resultado => {
    setBusy(true); setError("");
    try {
      const body = await jsonRequest(`/api/lift/pos-venda/${encodeURIComponent(sale.storeId)}/${encodeURIComponent(sale.liftPedidoId)}/resultado`, {
        method:"POST", headers:{ "Content-Type":"application/json" },
        body:JSON.stringify({ resultado, observacao:problem, confirmouEnvio:confirmed }),
      });
      onSaved(body.sale, body.completedReminderIds || []);
    } catch (err) { setError(err.message); }
    finally { setBusy(false); }
  };
  return <article style={{ padding:16, background:state.done?"#F0FDF4":state.overdueDays?"#FFF1F2":"#F8FAFC",
    border:`2px solid ${state.done?"#86EFAC":state.overdueDays?"#EF4444":"#CBD5E1"}`, borderRadius:12 }}>
    <div style={{ display:"flex", justifyContent:"space-between", gap:10, flexWrap:"wrap" }}>
      <strong>{sale.cliente?.nome || "Cliente"} · Pedido #{sale.liftPedidoId} · {sale.loja || `Loja ${sale.storeId}`}</strong>
      <strong style={{ color:state.overdueDays && !state.done?"#B91C1C":"#15803D" }}>
        {state.done?"Feito":state.overdueDays?`Atrasado ${state.overdueDays} dia(s)`:"A fazer"}
      </strong>
    </div>
    <div style={{ margin:"8px 0", fontSize:13, lineHeight:1.6 }}>
      Telefone: {sale.cliente?.telefone || "Não informado"} · Entrega detectada: {formatDay(state.deliveryDay)}
      {" · "}Prazo: {formatDay(state.dueOn)}
      <br />{(sale.itens || []).map(item => `${item.produto || item.produtoLift || "Produto"} (${item.quantidade || 1})`).join(", ")}
      {manager && <div>Responsável: {sale.vendidoPor?.nome || `#${sale.responsavelId}`}</div>}
      {sale.manualReminderPending && <div style={{ color:"#92400E", fontWeight:700 }}>Este cliente também tem lembrete manual de pós-venda.</div>}
      {sale.manualReminderPending && !sale.manualReminderLinked && !sale.manualReminderAmbiguous &&
        <div style={{ color:"#92400E" }}>Não foi possível comprovar que o lembrete é desta venda. Ele não será concluído automaticamente.</div>}
      {sale.manualReminderAmbiguous && <div role="alert" style={{ color:"#B91C1C", fontWeight:700 }}>
        Lembrete manual ambíguo: verifique os clientes com mesmo nome, consultor e data antes de concluir.
      </div>}
    </div>
    {state.done ? <div>
      Resultado: {sale.posVenda?.resultado === "problema"?"Cliente com problema":"Tudo certo"}
      {sale.posVenda?.observacao && ` · ${sale.posVenda.observacao}`}
      {sale.posVenda?.avaliacaoEnviadaEm && " · Avaliação enviada (confirmada pelo consultor)"}
      {manager && sale.posVenda?.resultado === "problema" && <p role="alert" style={{ color:"#B91C1C", fontWeight:700 }}>
        Atenção, gerente: cliente com problema — {sale.posVenda.observacao}
      </p>}
    </div> : <>
      {!sale.reviewLink && <p role="alert" style={{ color:"#B45309" }}>Link de avaliação desta loja ainda não configurado. “Tudo certo” ficará indisponível.</p>}
      {sale.reviewLink && !reviewText && <p role="alert" style={{ color:"#B45309" }}>Nome do cliente ou do consultor indisponível. Complete a ficha antes de pedir a avaliação.</p>}
      {reviewText && <div style={{ background:"#fff", padding:12, borderRadius:8, whiteSpace:"pre-wrap", marginBottom:10 }}>
        <strong>Mensagem pronta para enviar</strong><div>{reviewText}</div>
        <div style={{ display:"flex", gap:8, marginTop:8, flexWrap:"wrap" }}>
          <button type="button" style={buttonStyle} onClick={async () => {
            try { await navigator.clipboard.writeText(reviewText); setMessage("Mensagem copiada. Confirme o envio somente depois de enviá-la."); setError(""); }
            catch { setError("Não foi possível copiar. Selecione o texto manualmente."); }
          }}>Copiar mensagem</button>
          {number && <a href={`https://wa.me/${number}?text=${encodeURIComponent(reviewText)}`}
            target="_blank" rel="noopener noreferrer" style={buttonStyle}>⭐ Pedir avaliação ↗</a>}
          <span style={{ fontSize:11, color:"#64748B", alignSelf:"center" }}>Abre o WhatsApp com a mensagem pronta; você toca em Enviar.</span>
        </div>
      </div>}
      <label style={{ display:"block", margin:"10px 0" }}>
        <input type="checkbox" checked={confirmed} onChange={e => setConfirmed(e.target.checked)} />
        {" "}Confirmo que enviei a mensagem com o link de avaliação ao cliente
      </label>
      <button type="button" style={buttonStyle}
         disabled={busy || !confirmed || !reviewText || !number} onClick={() => submit("tudo_certo")}>Tudo certo · avaliação enviada</button>
      <div style={{ marginTop:14 }}>
        <label>Cliente com problema — descreva o que aconteceu
          <textarea style={{ ...inputStyle, display:"block", minHeight:70 }} value={problem}
            onChange={e => setProblem(e.target.value)} />
        </label>
        <button type="button" style={{ ...buttonStyle, marginTop:8 }} disabled={busy || !problem.trim()}
          onClick={() => submit("problema")}>Registrar problema e avisar gerente</button>
      </div>
      {message && <p role="status">{message}</p>}
      {error && <p role="alert" style={{ color:"#B91C1C" }}>{error}</p>}
    </>}
  </article>;
}

export default function LiftPostSale({ sales=[], error, onSaved, currentUser, onLinksUpdated }) {
  const visible = currentUser.role === "consultant"
    ? sales.filter(s => Number(s.responsavelId) === Number(currentUser.id))
    : currentUser.role === "manager"
      ? sales.filter(s => Number(s.storeId) === Number(currentUser.storeId)) : sales;
  const open = visible.filter(s => !s.postSaleState.done);
  const done = visible.filter(s => s.postSaleState.done);
  const manager = currentUser.role !== "consultant";
  if (currentUser.isDemo) return null;
  return <section id="pos-venda-lift" style={{ marginBottom:24 }}>
    <h2 style={{ fontSize:18 }}>Pós-venda LIFT</h2>
    <p style={{ fontSize:13, color:"#64748B" }}>A fazer: {open.length} · Atrasados: {open.filter(s => s.postSaleState.overdueDays > 0).length}</p>
    {["admin","superadmin"].includes(currentUser.role) && <ReviewLinksSettings onUpdated={onLinksUpdated} />}
    {error && <p role="alert" style={{ color:"#B91C1C" }}>{error}</p>}
    {!error && !visible.length && <p>Nenhum pós-venda LIFT disponível.</p>}
    <div style={{ display:"grid", gap:12 }}>
      {[...open.sort((a,b) => String(a.postSaleState.dueOn).localeCompare(String(b.postSaleState.dueOn))),
        ...done.sort((a,b) => String(b.posVenda?.feitoEm).localeCompare(String(a.posVenda?.feitoEm)))]
         .map(s => <PostSaleCard key={`${s.storeId}_${s.liftPedidoId}`} sale={s} manager={manager} currentUser={currentUser} onSaved={onSaved} />)}
    </div>
  </section>;
}